export default "__VITE_ASSET__d8e3bb14__"